export default __webpack_public_path__ + "static/media/registro-de-reportes.6663d528.svg";